import cn from 'classnames';
import { useMemo } from 'react';

import {
  Environment,
  Header,
  HeaderContextProvider,
  HeaderServiceConfiguration,
} from '@zooplus/header';

import { getAppConfig } from '@config/get-app-config';
import { useTranslation } from '@hooks/use-translations';
import commonStyles from '@styles/common.module.scss';
import { PAGE_PATH } from '@utilities/constants';
import '@zooplus/header/dist/es/shop-header.css';
import { getEnvType } from '@utilities/utils';

const minimalistHeaderPages = [
  PAGE_PATH.GUEST_PREVIEW,
  PAGE_PATH.NEW_PREVIEW,
  PAGE_PATH.LOGIN_SELECTION,
];

const HeaderComponent = () => {
  const { site, environment } = getAppConfig();
  const { ready } = useTranslation();

  const isMinimalistHeaderPage = minimalistHeaderPages.some((path) =>
    window.location.pathname.includes(path),
  );

  const customHeaderServiceConfiguration = useMemo((): HeaderServiceConfiguration => {
    const headerBaseConfig: HeaderServiceConfiguration = {
      environment: getEnvType(environment) as Environment,
      domain: site.domain,
      locale: site.locale,
      showCart: false,
      isNextJS: false,
      searchFlyoutOpen: false,
      showMultilanguage: false,
    };

    if (isMinimalistHeaderPage) {
      return {
        ...headerBaseConfig,
        showSearch: false,
        showCategories: false,
      };
    }

    return headerBaseConfig;
  }, [environment, site.domain, site.locale, isMinimalistHeaderPage]);

  if (!ready) {
    return <div className={commonStyles.headerPlaceholder}></div>;
  }

  return (
    <HeaderContextProvider configuration={customHeaderServiceConfiguration}>
      <div
        className={cn(commonStyles.headerPlaceholder, {
          [commonStyles.minimalistHeader]: isMinimalistHeaderPage,
        })}
        data-testid="shop-header-container">
        <Header />
      </div>
    </HeaderContextProvider>
  );
};

export default HeaderComponent;
